import { Text } from '@revelio/ui';

import styles from './top-companies-content.module.css';

type TopCompaniesContentProps = {
  companies: string[];
  nodeName: string;
};

export const TopCompaniesContent = ({
  companies,
  nodeName,
}: TopCompaniesContentProps) => (
  <div className={styles.content}>
    <Text fontSize="sm" weight="semibold" className={styles.text}>
      {nodeName}
    </Text>
    <Text fontSize="x-sm" className={styles.text}>
      <Text as="span" fontSize="x-sm" weight="semibold" className={styles.text}>
        Top Companies:{' '}
      </Text>
      <Text as="span" fontSize="x-sm" className={styles.companies}>
        {companies.join(', ')}
      </Text>
    </Text>
  </div>
);
